import type {
  Block,
  CalloutData,
  TextPart,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";

import "./warning.css";

export default function WarningView({ block }: { block: Block }) {
  const data = block.data as CalloutData;

  return (
    <div className="pdf-block pdf-warning">
      <div className="pdf-warning__header">
        <span className="pdf-warning__symbol">
          ⚠
        </span>
        <span className="pdf-warning__label">
          WARNING
        </span>
      </div>

      <div className="pdf-warning__content">
        {data.textParts.map((part: TextPart, i: number) => {
          if (part.type === "text") {
            return <span key={i}>{part.value}</span>;
          }

          return (
            <RefLink
              key={i}
              targetId={part.targetId}
              label={part.label}
              className="pdf-ref-link"
            />
          );
        })}
      </div>
    </div>
  );
}
